import React from "react"

const formLabel = "text-2xl leading-tight "
const formItem = "grid  mt-3"

const ContactForm = () => {
  return (
    <form
      className="grid"
      name="contact"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      action="/"
    >
      <input type="hidden" name="form-name" value="contact" />
      <div className="form__honeypot">
        <label>
          Don’t fill this out if you're human: <input name="bot-field" />
        </label>
      </div>
      <div className={`${formItem}`}>
        <label htmlFor="form__name" className={`${formLabel}`}>
          Name:<sup className="form__required">*</sup>
        </label>
        <input
          id="form__name"
          name="name"
          type="text"
          placeholder="Enter Your Name"
          className="formInput"
          required
        />
      </div>
      <div className={`${formItem}`}>
        <label htmlFor="form__tel" className={`${formLabel}`}>
          Phone Number:<sup className="form__required">*</sup>
        </label>
        <input
          className="formInput"
          name="phone"
          id="form__tel"
          type="tel"
          placeholder="555-555-5555"
          // pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
          required
        />
      </div>
      <div className={`${formItem}`}>
        <label htmlFor="form__email" className={`${formLabel}`}>
          Email:
        </label>
        <input
          className="formInput"
          name="email"
          id="form__email"
          type="email"
          placeholder="your@email.ca"
        />
      </div>
      <div className={`${formItem}`}>
        <label htmlFor="form__details" className={`${formLabel}`}>
          Details:<sup className="form__required">*</sup>
        </label>
        <textarea
          className="formInput"
          id="form__details"
          name="details"
          placeholder="Additional information for us to assist you better."
          required
        />
      </div>
      <div className="self-justify-end mt-3">
        <sup className="form__required">*</sup>Required
      </div>

      <button
        type="submit"
        className=" bg-white text-blue-dark leading-none p-3 pt-3 rounded text-2xl uppercase w-32 mt-8 self-justify-end hover:bg-blue-light hover:text-white font-bold"
      >
        Send
      </button>
    </form>
  )
}
export default ContactForm
